<div [hidden]="!active" class="tab-content-area">
    <ng-content></ng-content>
</div>